module.exports = __webpack_public_path__ + "static/media/group_30@3x.ae38f069.png";